import { format, isValid, parse } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const getDateFormat = (dateAndTime: string) => {
  if (dateAndTime)
    return format(new Date(dateAndTime), "MM/dd/yyyy")
};

export const getDateTimeFormat = (dateAndTime: string) => {
  if (dateAndTime)
    return format(toZonedTime(dateAndTime, "America/New_York"), 'MM/dd/yyyy HH:mm');
};

export function formatDispenseData(date: string): string {
  if (!date) return ""

  const parsedDate = parse(date, "yyyy-MM-dd", new Date())
  if (isValid(parsedDate)) {
    return format(parsedDate, "MM/dd/yyyy")
  } else {
    const msDate = parse(date, 'yyyyMMddHHmmss', new Date())
    if (isValid(msDate))
      return format(msDate, "MM/dd/yyyy")
    else
      return ""
  }
}
